import { MODULES, FUNCTIONS } from '../../../../shared/models/const.models';
import { HeaderMenuItem } from '../models/header-menu-item.model';

export const HEADER_MENU_ITEMS: HeaderMenuItem[] = [
  {
    id: 'rooms',
    labelKey: 'header.menu.rooms',
    route: '/rooms',
    icon: 'meeting_room',
    newsName: 'room',
    allowedRoles: [FUNCTIONS.MANAGE_ROOMS, FUNCTIONS.SECOND_VERIFICATION,],
    allowedModules: [MODULES.ROOMS],
  },
  {
    id: 'kitchen',
    labelKey: 'header.menu.kitchen',
    route: '/kitchen',
    icon: 'kitchen',
    newsName: 'kitchen',
    allowedRoles: [
      FUNCTIONS.MANAGE_KITCHEN,
      FUNCTIONS.CLEAN_KITCHEN,
    ],
    allowedModules: [MODULES.KITCHEN],
  },
  {
    id: 'clean-order',
    labelKey: 'header.menu.cleanOrder',
    route: '/clean-order',
    icon: 'cleaning_services',
    newsName: 'room',
    allowedRoles: [FUNCTIONS.FIRST_VERIFICATION],
    allowedModules: [MODULES.ROOMS],
  },
  {
    id: 'my-rooms',
    labelKey: 'header.menu.myRooms',
    route: '/my-rooms',
    icon: 'meeting_room',
    allowedRoles: [FUNCTIONS.CLEANER],
    allowedModules: [MODULES.ROOMS],
  },
  {
    id: 'hk-report',
    labelKey: 'header.menu.hkReport',
    route: '/hk-report',
    icon: 'assignment',
    allowedRoles: [FUNCTIONS.UPLOAD_HK_REPORT],
    allowedModules: [MODULES.ROOMS, MODULES.KITCHEN],
  },
  {
    id: 'assign-room',
    labelKey: 'header.menu.assignRoom',
    route: '/assign-room',
    icon: 'bed',
    allowedRoles: [FUNCTIONS.ASSIGN_CLEANERS],
    allowedModules: [MODULES.ROOMS],
  },
  {
    id: 'maintenance',
    labelKey: 'header.menu.maintenance',
    route: '/maintenance',
    icon: 'build',
    newsName: 'maintenance',
    allowedRoles: [
      FUNCTIONS.MANAGE_MAINTENANCE
    ],
    allowedModules: [MODULES.MAINTENANCE],
  },
  {
    id: 'my-maintenance',
    labelKey: 'header.menu.myMaintenance',
    route: '/my-maintenance',
    icon: 'build',
    allowedRoles: [FUNCTIONS.MAINTENANCE],
    allowedModules: [MODULES.MAINTENANCE],
  },
  {
    id: 'tasks',
    labelKey: 'header.menu.tasks',
    route: '/tasks',
    icon: 'list',
    newsName: 'task',
    allowedRoles: [
      FUNCTIONS.MANAGE_TASKS,
    ],
    allowedModules: [MODULES.TASKS],
  },
  {
    id: 'my-tasks',
    labelKey: 'header.menu.myTasks',
    route: '/my-tasks',
    icon: 'list',
    newsName: 'task',
    allowedRoles: [FUNCTIONS.MY_TASKS],
    allowedModules: [MODULES.TASKS],
  },
  {
    id: 'hotel-config',
    labelKey: 'header.menu.hotelConfig',
    route: '/hotel-config',
    icon: 'settings',
    allowedRoles: [FUNCTIONS.SUPERADMIN],
  },
  {
    id: 'config-flow',
    labelKey: 'header.menu.configFlow',
    route: '/config-flow',
    icon: 'settings',
    allowedRoles: [FUNCTIONS.SUPERADMIN],
  },
  {
    id: 'role-config',
    labelKey: 'header.menu.roleConfig',
    route: '/role-config',
    icon: 'admin_panel_settings',
    allowedRoles: [FUNCTIONS.SUPERADMIN],
  },
  {
    id: 'users',
    labelKey: 'header.menu.users',
    route: '/users',
    icon: 'people',
    allowedRoles: [FUNCTIONS.ADMIN, FUNCTIONS.SUPERADMIN],
  },
  {
    id: 'cleaners',
    labelKey: 'header.menu.cleaners',
    route: '/cleaners',
    icon: 'person',
    allowedRoles: [FUNCTIONS.MANAGE_CLEANERS],
    allowedModules: [MODULES.ROOMS, MODULES.KITCHEN],
  },
  {
    id: 'stats',
    labelKey: 'header.menu.stats',
    route: '/stats',
    icon: 'bar_chart',
    allowedModules: [MODULES.STATS],
    allowedRoles: [
      FUNCTIONS.VIEW_CLEANING_STATS,
      FUNCTIONS.VIEW_KITCHEN_STATS,
      FUNCTIONS.VIEW_MAINTENANCE_STATS,
      FUNCTIONS.VIEW_ROOM_STATS,
    ],
  },
  {
    id: 'daily-report',
    labelKey: 'header.menu.dailyReport',
    route: '/daily-report',
    icon: 'summarize',
    allowedModules: [MODULES.DAILY_REPORT],
    allowedRoles: [
      FUNCTIONS.VIEW_DAILY_REPORT,
    ],
  },
];
